const actions = {
    createComment: (comment = CONSTANTS.STYLE, origin) => {
        return document.createComment(comment + origin)
    }
};

const CONSTANTS = {
    STYLE: "Style injection by ",
    REMOVE: "Element removed by ",
    ERROR: "Error in ",
};

const commentator = {
    getPresets: () => { return CONSTANTS },
    insertCommentBefore: (element, origin, type) => {
        const newComment = actions.createComment(type, origin);

        if (element.previousSibling && element.previousSibling.data) {
            if (newComment.data !== element.previousSibling.data) {
                element.parentNode.insertBefore(newComment, element);
            }
        } else {
            element.parentNode.insertBefore(newComment, element);
        }
    },
    insertCommentAfter: (element, origin, type) => {
        const newComment = actions.createComment(type, origin);
        if (element.nextSibling && element.nextSibling.data) {
            if (newComment.data !== element.nextSibling.data) {
                element.parentNode.insertBefore(newComment, element.nextSibling);
            }
        } else {
            element.parentNode.insertBefore(newComment, element.nextSibling);
        }
    }
};

export { commentator };
